// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("./MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_MutableQueue = require("rescript/lib/js/belt_MutableQueue.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function exprSrcIsProved(exprSrc) {
  if (typeof exprSrc === "number") {
    return true;
  }
  switch (exprSrc.TAG | 0) {
    case /* Hypothesis */0 :
        return true;
    case /* Assertion */1 :
        return exprSrc.args.every(function (arg) {
                    return Belt_Option.isSome(arg.proof);
                  });
    case /* AssertionWithErr */2 :
        return false;
    
  }
}

function pnGetExpr(node) {
  return node.expr;
}

function pnGetProof(node) {
  return node.proof;
}

function pnGetFParents(node) {
  return node.fParents;
}

function pnGetEParents(node) {
  return node.eParents;
}

function pnIsInvalidFloating(node) {
  return node.isInvalidFloating;
}

function pnSetInvalidFloating(node) {
  node.isInvalidFloating = true;
}

function pnGetDist(node) {
  return node.dist;
}

function pnSetDist(node, dist) {
  node.dist = dist;
}

function pnGetDbg(node) {
  return node.dbg;
}

function ptGetFrms(tree) {
  return tree.frms;
}

function ptGetParenCnt(tree) {
  return tree.parenCnt;
}

function ptIsDisj(tree, n, m) {
  return MM_context.disjContains(tree.disj, n, m);
}

function ptIsNewVarDef(tree, expr) {
  return Belt_HashSet.has(tree.newVars, expr);
}

function ptGetHypByExpr(tree, expr) {
  return Belt_HashMap.get(tree.hypsByExpr, expr);
}

function ptGetHypByLabel(tree, label) {
  return Belt_HashMapString.get(tree.hypsByLabel, label);
}

function ptGetMaxVar(tree) {
  return tree.maxVar;
}

function ptGetCtxMaxVar(tree) {
  return tree.ctxMaxVar;
}

function ptGetRootStmts(tree) {
  return tree.rootStmts;
}

function ptGetDbg(tree) {
  return tree.dbg;
}

function ptGetCopyOfNewVars(tree) {
  return Belt_HashSet.toArray(tree.newVars);
}

function ptGetDisj(tree) {
  return tree.disj;
}

function ptMake(frms, hyps, ctxMaxVar, disj, parenCnt, exprToStr) {
  var hypsArr = Belt_MapString.toArray(hyps);
  return {
          frms: frms,
          hypsByExpr: Belt_HashMap.fromArray(hypsArr.map(function (param) {
                    var hyp = param[1];
                    return [
                            hyp.expr,
                            hyp
                          ];
                  }), MM_context.ExprHash),
          hypsByLabel: Belt_HashMapString.fromArray(hypsArr),
          ctxMaxVar: ctxMaxVar,
          maxVar: ctxMaxVar,
          newVars: Belt_HashSet.make(16, MM_context.ExprHash),
          disj: disj,
          parenCnt: parenCnt,
          nodes: Belt_HashMap.make(16, MM_context.ExprHash),
          rootStmts: [],
          dbg: Belt_Option.map(exprToStr, (function (exprToStr) {
                  return {
                          newVars: [],
                          disj: [],
                          exprToStr: exprToStr
                        };
                }))
        };
}

function pnGetExprStr(node) {
  var match = node.dbg;
  if (match !== undefined) {
    return match.exprStr;
  } else {
    return node.expr.map(function (prim) {
                  return String(prim);
                }).join(" ");
  }
}

function ptGetNode(tree, expr) {
  var node = Belt_HashMap.get(tree.nodes, expr);
  if (node !== undefined) {
    return node;
  }
  var node$1 = {
    expr: expr,
    fParents: undefined,
    eParents: [],
    children: [],
    proof: undefined,
    isInvalidFloating: false,
    dist: undefined,
    dbg: Belt_Option.map(tree.dbg, (function (dbg) {
            return {
                    exprStr: Curry._1(dbg.exprToStr, expr)
                  };
          }))
  };
  Belt_HashMap.set(tree.nodes, expr, node$1);
  return node$1;
}

function ptAddRootStmt(tree, stmt) {
  var match = tree.rootStmts.find(function (existingStmt) {
        return MM_context.exprEq(existingStmt.expr, stmt.expr);
      });
  if (match !== undefined) {
    return ;
  } else {
    tree.rootStmts.push(stmt);
    return ;
  }
}

function ptClearDists(tree) {
  Belt_HashMap.forEach(tree.nodes, (function (param, node) {
          node.dist = undefined;
        }));
}

function pnGetProofFromParents(node) {
  var fParents = node.fParents;
  var fProof = fParents !== undefined ? Caml_option.undefined_to_opt(fParents.find(exprSrcIsProved)) : undefined;
  if (Belt_Option.isSome(fProof)) {
    return fProof;
  } else {
    return Caml_option.undefined_to_opt(node.eParents.find(exprSrcIsProved));
  }
}

function pnAddParent(node, parent, isEssential) {
  if (!Belt_Option.isNone(node.proof)) {
    return ;
  }
  var newParentWasAdded = false;
  var parents;
  if (isEssential) {
    parents = node.eParents;
  } else {
    var parents$1 = node.fParents;
    if (parents$1 !== undefined) {
      parents = parents$1;
    } else {
      var parents$2 = [parent];
      node.fParents = parents$2;
      newParentWasAdded = true;
      parents = parents$2;
    }
  }
  if (!newParentWasAdded) {
    var existingParent = parents.find(function (par) {
          if (typeof par === "number") {
            if (typeof parent === "number") {
              return true;
            } else {
              return false;
            }
          }
          switch (par.TAG | 0) {
            case /* Hypothesis */0 :
                if (typeof parent === "number" || parent.TAG !== /* Hypothesis */0) {
                  return false;
                } else {
                  return par.label === parent.label;
                }
            case /* Assertion */1 :
                var aArgs = par.args;
                if (typeof parent === "number") {
                  return false;
                }
                if (parent.TAG !== /* Assertion */1) {
                  return false;
                }
                var bArgs = parent.args;
                if (par.frame.label === parent.frame.label && aArgs.length === bArgs.length) {
                  return aArgs.every(function (aArg, idx) {
                              return MM_context.exprEq(aArg.expr, Caml_array.get(bArgs, idx).expr);
                            });
                } else {
                  return false;
                }
            case /* AssertionWithErr */2 :
                return false;
            
          }
        });
    if (existingParent !== undefined) {
      if (exprSrcIsProved(existingParent)) {
        throw {
              RE_EXN_ID: MM_parser.MmException,
              _1: {
                msg: "Unexpected: an unproved node '" + pnGetExprStr(node) + "' has a proved parent."
              },
              Error: new Error()
            };
      }
      
    } else {
      parents.push(parent);
      newParentWasAdded = true;
    }
  }
  if (!newParentWasAdded) {
    return ;
  }
  if (typeof parent !== "number" && parent.TAG === /* Assertion */1) {
    parent.args.forEach(function (__x) {
          if (MM_context.exprEq(__x.expr, node.expr)) {
            return ;
          }
          var match = __x.children.find(function (existingChild) {
                return MM_context.exprEq(existingChild.expr, node.expr);
              });
          if (match !== undefined) {
            return ;
          } else {
            __x.children.push(node);
            return ;
          }
        });
  }
  if (exprSrcIsProved(parent)) {
    if (!Belt_Option.isNone(node.proof)) {
      return ;
    }
    var nodeProof = pnGetProofFromParents(node);
    if (nodeProof === undefined) {
      return ;
    }
    node.proof = nodeProof;
    var nodesToMarkProved = Belt_MutableQueue.fromArray(node.children);
    while(!Belt_MutableQueue.isEmpty(nodesToMarkProved)) {
      var curNode = Belt_Option.getExn(Belt_MutableQueue.pop(nodesToMarkProved));
      if (Belt_Option.isNone(curNode.proof)) {
        var curNodeProof = pnGetProofFromParents(curNode);
        if (curNodeProof !== undefined) {
          curNode.proof = curNodeProof;
          curNode.children.forEach(function (param) {
                return Belt_MutableQueue.add(nodesToMarkProved, param);
              });
        }
        
      }
      
    };
    return ;
  }
  
}

function ptAddNewVar(tree, typ) {
  tree.maxVar = tree.maxVar + 1 | 0;
  var newVar = tree.maxVar;
  Belt_HashSet.add(tree.newVars, [
        typ,
        newVar
      ]);
  var match = tree.dbg;
  if (match !== undefined) {
    match.newVars.push(Curry._1(match.exprToStr, [
              typ,
              newVar
            ]));
  }
  return newVar;
}

function ptAddDisjPair(tree, n, m) {
  MM_context.disjAddPair(tree.disj, n, m);
  var match = tree.dbg;
  if (match !== undefined) {
    match.disj.push(Curry._1(match.exprToStr, [
              n,
              m
            ]));
    return ;
  }
  
}

exports.ptMake = ptMake;
exports.ptGetFrms = ptGetFrms;
exports.ptGetHypByExpr = ptGetHypByExpr;
exports.ptGetHypByLabel = ptGetHypByLabel;
exports.ptGetMaxVar = ptGetMaxVar;
exports.ptGetCtxMaxVar = ptGetCtxMaxVar;
exports.ptGetParenCnt = ptGetParenCnt;
exports.ptIsDisj = ptIsDisj;
exports.ptIsNewVarDef = ptIsNewVarDef;
exports.ptGetRootStmts = ptGetRootStmts;
exports.ptGetNode = ptGetNode;
exports.ptAddNewVar = ptAddNewVar;
exports.ptAddDisjPair = ptAddDisjPair;
exports.ptAddRootStmt = ptAddRootStmt;
exports.ptClearDists = ptClearDists;
exports.ptGetDbg = ptGetDbg;
exports.ptGetCopyOfNewVars = ptGetCopyOfNewVars;
exports.ptGetDisj = ptGetDisj;
exports.pnGetExpr = pnGetExpr;
exports.pnGetProof = pnGetProof;
exports.pnGetFParents = pnGetFParents;
exports.pnGetEParents = pnGetEParents;
exports.pnAddParent = pnAddParent;
exports.pnIsInvalidFloating = pnIsInvalidFloating;
exports.pnSetInvalidFloating = pnSetInvalidFloating;
exports.pnGetDist = pnGetDist;
exports.pnSetDist = pnSetDist;
exports.pnGetDbg = pnGetDbg;
/* MM_context Not a pure module */
